<template>
  <fragment>
    <form @submit.prevent="handleGetRequets">
      <page-head title="صحائف الدعوى">
        <v-row>
          <v-col
            v-for="(filter, index) in filters"
            :key="filter.name"
            cols="12"
            :lg="index <= 1 ? '2' : '3'"
          >
            <naj-input
              v-mask="'##########'"
              :type-id="filter.typeId"
              :label="filter.label"
              :value.sync="searchQuery[filter.name]"
              :items="getSelectOptions(filter.name)"
              item-text="name"
              item-value="id"
            ></naj-input>
          </v-col>

          <v-col
            cols="1"
            class="d-flex align-center"
          >
            <naj-button
              type="submit"
              :loading="loading"
              full-width
            >
              البحث
            </naj-button>
          </v-col>
        </v-row>
      </page-head>
    </form>

    <page-content>
      <horizontal-naj-box
        title="طلبات صحائف الدعوى"
        disable-collapsing
      >
        <template v-slot:header="{}">
          <naj-button
            color="primary"
            @click="handleNewRequest"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            طلب جديد
          </naj-button>
        </template>

        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="data.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item, index}">
            <div class="actions-wrapper">
              <router-link :to="`/lawsuit-requests/${item.objectKey}`">
                <naj-button
                  type="button"
                  outlined
                  size="small"
                >
                  عرض
                </naj-button>
              </router-link>

              <naj-button
                v-if="showCancelButton(item.requestStatusId)"
                color="error"
                type="button"
                outlined
                size="small"
                :disabled="item.isServicesCenterRequest"
                @click="removeItem(index)"
              >
                إلغاء
              </naj-button>
            </div>
          </template>

          <template v-slot:item.showRequest="{item}">
            <naj-button
              v-if="isRequestNotCompleted(item.requestStatusId)"
              size="small"
              outlined
              tooltip-message="لمعرفة أسباب عدم الاكتمال و كذلك العمليات التي تمت على الطلب، اضغط هنا"
              @click="handleOpenRecordModel(item.objectKey)"
            >
              سجل الطلب
            </naj-button>
          </template>
        </naj-data-table>
      </horizontal-naj-box>

      <request-records-modal
        :request-object-key="activeRequestRecords"
        :modal-visibility.sync="recordsModal[activeRequestRecords]"
        @onClose="handleCloseRecordModel(activeRequestRecords)"
      >
      </request-records-modal>
    </page-content>

    <naj-confirmation
      :show-modal="showVacationModal"
      :title="vacationModal.title"
      :message="vacationModal.message"
      close-btn-label="إغلاق"
      @cancel="showVacationModal = false"
    ></naj-confirmation>

    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.cancelConfirmation"
      :message="local.common.cancelConfirmationMessage"
      :ok-btn-label="local.common.cancel"
      @ok="removeConfirmed"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import RequestRecordsModal from '@/modules/lawsuit/components/request-records-modal';
import { requestStatus, requestReplyTypes } from '@/helpers/enum';
import Vacations from '@/modules/lawsuit/services/vacations';

const { mapActions } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  data() {
    return {
      showVacationModal: false,
      showRemovePopup: false,
      selectedIndexToDelete: null,
      vacationModal: {
        title: null,
        message: null,
      },
      loading: false,
      activeRequestRecords: null,
      recordsModal: {},
      data: { list: [] },
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      searchQuery: {},
      filters: [
        {
          name: 'requestCode',
          label: 'رقم الطلب',
          typeId: 1,
        },
        {
          name: 'courtId',
          label: 'المحكمة',
          typeId: 4,
        },
        {
          name: 'fromRequestDate',
          label: 'التاريخ من',
          typeId: 3,
        },
        {
          name: 'toRequestDate',
          label: 'التاريخ الى',
          typeId: 3,
        },
      ],
      headers: [
        {
          value: 'requestCode',
          text: 'رقم الطلب',
        },
        {
          value: 'courtName',
          text: 'المحكمة',
        },
        {
          value: 'caseTypeName',
          text: 'نوع الدعوى',
        },
        {
          value: 'prosecutorName',
          text: 'اسم المدعي',
        },
        {
          value: 'defendantName',
          text: 'اسم المدعى عليه',
        },
        {
          value: 'requestStatusName',
          text: 'حالة الطلب',
          width: '10%',
        },
        {
          value: 'showRequest',
          text: 'سجل الطلب',
        },
        {
          value: 'action',
          text: 'الإجراء',
        },
      ],
    };
  },
  methods: {
    ...mapActions(['getRequests']),
    ...mapLawsuitActions(['submitCaseReply']),
    ...mapLUTActions(['getCourts']),
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.handleGetRequets();
    },
    handleGetRequets() {
      this.loading = true;

      this.getRequests({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSelectOptions(name) {
      if (name === 'courtId') {
        return this.courts;
      }

      return [];
    },
    handleOpenRecordModel(objectKey) {
      this.activeRequestRecords = objectKey;
      this.recordsModal = {
        ...this.recordsModal,
        [objectKey]: true,
      };
    },
    handleCloseRecordModel(objectKey) {
      this.activeRequestRecords = null;
      this.recordsModal = {
        ...this.recordsModal,
        [objectKey]: false,
      };
    },
    isRequestNotCompleted(statusId) {
      return statusId === requestStatus.NotCompleted || statusId === requestStatus.saved || statusId === requestStatus.canceledForNotBeingReviewd;
    },
    showCancelButton(statusId) {
      return statusId === requestStatus.draft || statusId === requestStatus.NotCompleted;
    },
    handleNewRequest() {
      const service = Vacations.check();

      if (service.locked) {
        this.vacationModal = {
          title: 'الخدمة غير متاحة',
          message: service.message,
        };

        this.showVacationModal = true;
      } else {
        this.$router.push({ path: '/lawsuit-requests' });
      }
    },
    removeItem(index) {
      this.showRemovePopup = true;
      this.selectedIndexToDelete = index;
    },
    removeConfirmed() {
      const request = this.data.list[this.selectedIndexToDelete];
      const apiRequestBody = {
        requestObjectKey: request.objectKey,
        requestReply: requestReplyTypes.CancelRequest.id,
        reasons: ['إلغاء صحيفة دعوى-مقدم الطلب'],
        disbaleRedirect: true,
      };

      this.submitCaseReply(apiRequestBody).then(() => {
        this.toaster.success(`تم ${requestReplyTypes.CancelRequest.name}`);
        this.handleGetRequets();
      })
        .finally(() => {
          this.selectedIndexToDelete = null;
          this.showRemovePopup = false;
        });
    },
  },
  mounted() {
    this.handleGetRequets();
    this.getCourts();
  },
  computed: mapLUTState(['courts']),
  components: { RequestRecordsModal },
};
</script>

<style lang="scss" scoped>
.new-request-button {
  margin-right: auto;
}
.search-button {
  margin-right: auto;
}
.actions-wrapper {
  display: flex;
}

::v-deep .naj-box-header {
  direction: ltr;
  justify-content: space-between;
}
</style>
